<template>
  <div>
    <OnboardingTopBar />
    <OnboardingHome />
  </div>
</template>

<script>
import OnboardingTopBar from '@/components/onboarding/OnboardingTopBar';
import OnboardingHome from '@/components/onboarding/OnboardingHome';

import { ONBOARDING_STATUS } from '@/utils/constants';
import { trackEventWithUserProperties } from '@/utils/mixpanel';
import onboardingModel from '@/mixins/onboarding-model';
import { mapActions } from 'vuex';

export default {
  name: 'Onboarding',
  components: {
    OnboardingTopBar,
    OnboardingHome,
  },
  mixins: [
    onboardingModel,
  ],
  created() {
    this.$vuetify.theme.isDark = false;

    if (this.isFirstEditor) {
      this.updateOnboardingStatus(ONBOARDING_STATUS.DOING);
    }

    trackEventWithUserProperties('ST OnboardingWizard Start View', { editorType: this.getEditorType() });
    this.updateUserOnboarding(ONBOARDING_STATUS.DOING);
  },
  methods: {
    ...mapActions('dashboard', [
      'updateOnboardingStatus',
    ]),
  },
};
</script>

<style lang="scss" scoped>
</style>
